"use client"
import React from 'react'
import MaxWidthContainer from './max-width-container'
import CustomLabel from '../ui/custom-label'
import { api } from '@/trpc/react'
import { Skeleton } from '../ui/skeleton'
import TrekDestinationCard from './trek-destination-card'

export default function TrekCategory() {
    const { data, isLoading } = api.trek_category.get_curated_trek_categories.useQuery()

    if (isLoading) return (
        <section className='py-8 md:py-12'>
            <MaxWidthContainer className='space-y-5'>
                <CustomLabel label='Trek Categories' />
                <div className='grid sm:grid-cols-2  lg:grid-cols-3 gap-3 md:gap-6 lg:gap-4 xl:gap-8'>
                    {
                        Array.from({ length: 6 }).map((load, _index) => (
                            <Skeleton key={_index} className='h-64 lg:h-56 xl:h-[17rem] bg-gray-400 rounded-lg' />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )

    if (!data || data.length < 1) return null

    return (
        <section className='py-8 lg:py-12 bg-[#007A7A]/5'>
            <MaxWidthContainer className='space-y-5'>
                <CustomLabel label='Trek Categories' />
                <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 lg:gap-4 xl:gap-8'>
                    {
                        data.map((trekcat) => (
                            <TrekDestinationCard
                                key={trekcat.slug}
                                href={trekcat.slug}
                                image={trekcat.cover_image_url}
                                price={trekcat.tripLinks.length > 0 ? trekcat.tripLinks[0]?.trip.trip_batches[0]?.main_price : 0}
                                title={trekcat.title}
                                tours={trekcat.tripLinks.length}
                            />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )
}
